/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BoxShadow } from '../../../../../shared/GlobalStyles';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import {
  setIsUnsavedDashModalShowing,
  setNextLocation as setNextSCLocation,
  setSaveDashboardModal,
} from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import Button from '../../../../../shared/_TBComponents/Button';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';
import {
  setSaveLMDashModal,
  setUnsavedLMDashModal,
  setNextLocation as setNextLMLocation,
  setIsDashboardDisplayed as setIsLMDashboardDisplayed,
  setIsNewLMDash,
} from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import {
  setSaveFPDashModal,
  setUnsavedFPDashModal,
  setNextLocation as setNextFPLocation,
  setIsDashboardDisplayed as setIsFPDashboardDisplayed,
} from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import {
  setSaveVTDashModal,
  setUnsavedVTDashModal,
  setNextLocation as setNextVTDashLocation,
  setIsVTDashDisplayed,
} from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import SharedTemplateModalContainer from './SharedTemplateModalContainer';
import {
  setIsVBTDashDisplayed, setNextVBTDashLocation, setSaveVBTDashModal, setUnsavedVBTDashModal,
} from '../../../../vbt-dashboard/ducks/vbtDashboardActions';

const ModalContainer = styled('div')`
  z-index: 1003;
  min-height: 270px;
  width: 55vw;
  overflow: auto;
  @media only screen and (max-width: 768px) {
    width: 90vw;
  }
  min-width: 430px;
  max-height: calc(100vh - 20px);
  position: absolute;
  border-radius: 12px;
  left: 50%;
  top: 50%;
  right: 50%;
  transition: all 0.3s linear, opacity 0.3s ease-out;
  opacity: ${(props) => (props.isActive ? '1' : '0')};
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isActive ? 'translate(-50%,-50%)' : 'translate(-50%, 300%)')};
  user-select: none;
`;

const RemoveDiv = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 1001;
  color: #444444;
  background: white;
  .remove-div-icon {
    cursor: pointer;
  }
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
`;

const ContentContainer = styled('div')`
  margin: 30px 15px;
  font-family: 'Nunito Sans';
  font-size: 16px;
`;

const ModalHeader = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 40px;
`;

const HeaderIconContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  height: 52px;
  width: 52px;
  border-radius: 50%;
`;

const ModalHeaderText = styled('div')`
  font-size: 24px;
  font-family: 'Nunito Sans';
  font-weight: 400;
  margin-top: 10px;
`;

const PortalContainer = styled('div')`
  width: 100%;
  background: white;
  box-shadow: ${BoxShadow};
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  overflow: auto;
`;

const RelativePortalContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const SaveButtonContainer = styled('div')`
  padding: 0px 10px;
  margin-bottom: 10px;
`;

const CloseButtonContainer = styled('div')`
  padding: 0px 10px;
`;

const SharedTemplateUnsavedModal = ({ dashboard, legacyName }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  let isModalShowing = false;
  let setUnsavedModalShowing = () => {};
  let setSaveModalShowing = () => {};
  let nextLocation = null;
  let setNextLocation = () => {};
  let setIsDashboardDisplayed = () => {};

  if (dashboard === 'Load Monitoring') {
    isModalShowing = useSelector(
      (state) => state.loadMonitoringDashboard.ui.unsavedModalShowing,
    );
    setUnsavedModalShowing = setUnsavedLMDashModal;
    setSaveModalShowing = setSaveLMDashModal;
    nextLocation = useSelector(
      (state) => state.loadMonitoringDashboard.data.nextLocation,
    );
    setNextLocation = setNextLMLocation;
    setIsDashboardDisplayed = setIsLMDashboardDisplayed;
  }

  if (dashboard === 'Force Plate') {
    isModalShowing = useSelector(
      (state) => state.forcePlateDashboard.ui.unsavedModalShowing,
    );
    setUnsavedModalShowing = setUnsavedFPDashModal;
    setSaveModalShowing = setSaveFPDashModal;
    nextLocation = useSelector(
      (state) => state.forcePlateDashboard.data.nextLocation,
    );
    setNextLocation = setNextFPLocation;
    setIsDashboardDisplayed = setIsFPDashboardDisplayed;
  }

  if (dashboard === 'KPI Tracker') {
    isModalShowing = useSelector(
      (state) => state.sportCoachDashboard.ui.isUnsavedDashModalShowing,
    );
    setUnsavedModalShowing = setIsUnsavedDashModalShowing;
    setSaveModalShowing = setSaveDashboardModal;
    nextLocation = useSelector(
      (state) => state.sportCoachDashboard.data.nextLocation,
    );
    setNextLocation = setNextSCLocation;
  }

  if (dashboard === 'Volume Tracker') {
    isModalShowing = useSelector(
      (state) => state.volumeTrackerDashboard.ui.unsavedModalShowing,
    );
    setUnsavedModalShowing = setUnsavedVTDashModal;
    setSaveModalShowing = setSaveVTDashModal;
    nextLocation = useSelector(
      (state) => state.volumeTrackerDashboard.data.nextLocation,
    );
    setNextLocation = setNextVTDashLocation;
  }

  if (dashboard === 'VBT') {
    isModalShowing = useSelector(
      (state) => state.vbtDashboard.ui.unsavedModalShowing,
    );
    nextLocation = useSelector(
      (state) => state.vbtDashboard.data.nextLocation,
    );
    setNextLocation = setNextVBTDashLocation;
    setSaveModalShowing = setSaveVBTDashModal;
    setUnsavedModalShowing = setUnsavedVBTDashModal;
  }

  const handleSave = () => {
    // Amplitude tracking
    dashboardTracker(
      `${legacyName} Dashboard`,
      'Unsaved Dash Warning',
      'Save dashboard clicked',
    );
    batch(() => {
      dispatch(setUnsavedModalShowing(false));
      dispatch(setSaveModalShowing(true));
      dispatch(setNextLocation(null));
    });
  };

  const handleCloseWithNavigation = () => {
    // Amplitude tracking
    dashboardTracker(
      `${legacyName} Dashboard`,
      'Unsaved Dash Warning',
      'Continue without saving clicked',
    );
    batch(() => {
      dispatch(setUnsavedModalShowing(false));
      if (nextLocation) {
        if (
          (dashboard === 'Force Plate'
            && nextLocation === '/ams/force-plate-dashboard')
          || (dashboard === 'Load Monitoring'
            && nextLocation === '/ams/load-monitoring-dashboard')
          || (dashboard === 'Volume Tracker'
            && nextLocation === '/ams/volume-tracker')
          || (dashboard === 'VBT'
            && nextLocation === '/ams/vbt-dashboard')
        ) {
          batch(() => {
            if (dashboard === 'Load Monitoring') {
              dispatch(setIsNewLMDash(false));
            }
            if (dashboard === 'Volume Tracker') {
              dispatch(setIsVTDashDisplayed(false));
            }
            if (dashboard === 'VBT') {
              dispatch(setIsVBTDashDisplayed(false));
            }
            dispatch(setNextLocation(null));
            dispatch(setIsDashboardDisplayed(false));
            dispatch(setNextLocation(null));
          });
        } else {
          history.push(nextLocation);
          dispatch(setNextLocation(null));
        }
      }
    });
  };

  const handleClose = () => {
    // Amplitude tracking
    dashboardTracker(
      `${legacyName} Dashboard`,
      'Unsaved Dash Warning',
      'Modal closed',
    );
    batch(() => {
      dispatch(setUnsavedModalShowing(false));
      dispatch(setNextLocation(null));
    });
  };

  return (
    <>
      <ModalContainer isActive={isModalShowing} customWidth='700px'>
        <RelativePortalContainer>
          <div />
          <PortalContainer>
            <RemoveDiv>
              <ModalHeader>
                <HeaderIconContainer>
                  <IcomoonReact iconSet={iconSet} size={20} icon='warning' />
                </HeaderIconContainer>
                <ModalHeaderText>Dashboard Not Saved</ModalHeaderText>
              </ModalHeader>
              <div className='remove-div-icon' onClick={handleClose}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon='remove'
                  color='black'
                />
              </div>
            </RemoveDiv>
            <ContentContainer>
              This dashboard has not been saved, are you sure you want to exit
              without saving? Exiting now will discard any unsaved progress. If
              you have made any updates, close this modal to review and save
              your changes.
            </ContentContainer>
            <ButtonsContainer>
              <SaveButtonContainer>
                <Button
                  bgColor='#424242'
                  fontSize='14px'
                  fullWidth
                  large
                  name='Save Dashboard'
                  noBorder
                  onClick={handleSave}
                  square
                  txtColor='#FFFFFF'
                  upperCase
                />
              </SaveButtonContainer>

              <CloseButtonContainer>
                <Button
                  borderColor='#424242'
                  bgColor='#FFFFFF'
                  fontSize='14px'
                  fullWidth
                  large
                  name='Continue Without Saving'
                  onClick={handleCloseWithNavigation}
                  square
                  txtColor='#424242'
                  upperCase
                />
              </CloseButtonContainer>
            </ButtonsContainer>
          </PortalContainer>
        </RelativePortalContainer>
      </ModalContainer>
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
      />
    </>
  );
};

SharedTemplateUnsavedModal.defaultProps = {
  dashboard: 'Wearables',
  legacyName: 'Wearables',
};

SharedTemplateUnsavedModal.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
};

export default SharedTemplateUnsavedModal;
